import Text from "@commons/Typography/Text";
import { RELEASE_STATUS_MAP } from "@typings/entities/releases/filter";

function ReleasesStatus(value: unknown) {
  const key = String(value ?? "undefined") as keyof typeof RELEASE_STATUS_MAP;
  const status = RELEASE_STATUS_MAP[key] || RELEASE_STATUS_MAP.undefined;

  return (
    <Text
      size="sm"
      className={`rounded-full py-1 px-4 w-fit font-roboto text-white text-nowrap ${status.style}`}
    >
      {status.label}
    </Text>
  );
}

export default ReleasesStatus;
